// @flow
import OldAdminLink from './OldAdminLink';
export default OldAdminLink;
